const $ = jQuery.noConflict();

class Accordions {
    constructor(trigger) {
        this.trigger = $(trigger);
    }
    init() {
        this.bindEvents();
    }
    menuAccordion() {
        this.addArrow();
        // $('.accordion-trigger').on('click', this.clickArrow);
        $('.arrow-menu-acc').on('click', this.toggleMenu);
        $('.arrow-menu-acc').on('click', this.setCurrentImage);
        $('.arrow-menu-acc-icon').on('mouseover', this.moveAccItems);
        $('.arrow-menu-acc-icon').on('mouseout', this.resetAccItems);
    }

    clickArrow() {
        // this.toggleMenu();
        // this.setCurrentImage();
    }
    addArrow() {
        this.trigger.find('> a').after('<span class="arrow-menu-acc"><i class="arrow-menu-acc-icon"></i></span>');
    }
    moveAccItems() {
        if ( !$(this).closest('.accordion-trigger').hasClass('active')) {
            $(this).closest('.accordion-trigger').css({
                paddingBottom: '10px',
            });
        }
    }

    resetAccItems() {
        $(this).closest('.accordion-trigger').css({
            paddingBottom: '0px',
        });
    }

    toggleMenu() {
        const activeItems = $('.accordion-trigger.active');
        if ($(this).parent().hasClass('active')) {
            activeItems.each(function () {
                $(this).removeClass('active');
                $(this).parent().find('.sub-menu').stop()
                    .slideUp(400);
            });
        } else {
            activeItems.each(function () {
                $(this).removeClass('active');
                $(this).parent().find('.sub-menu').stop()
                    .slideUp(400);
            });
            $(this).parent().addClass('active');
        }

        $(this).parent().find('.sub-menu').stop()
            .slideToggle(400);
    }

    setCurrentImage() {
        const images = $('.image-wrapper');
        // check on click if any accordion item is active
        // if so, change default image to this accordion item image
        if ($('.accordion-trigger.active').length > 0) {
            const that = $('.accordion-trigger.active');
            const dataAttr = that.find('.inner-trigger').attr('data-image');

            images.removeClass('visible current-visible-image');
            $(`[data-image= ${dataAttr}]`).addClass('visible current-visible-image');
        } else {
            images.removeClass('visible current-visible-image');
            images.first().addClass('visible  current-visible-image');
        }
    }
    bindEvents() {
        this.trigger.on('click', this.toggleAccordion);
    }
    toggleAccordion() {
        $(this).parent().toggleClass('active');
        $(this).next().stop().slideToggle(250);
    }
}

const shortcodeAcc = new Accordions('.single-accordion__title');
const menuAcc = new Accordions('.accordion-trigger');

export {
    shortcodeAcc,
    menuAcc,
};
